exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.dx-button {\r\n    color : rgb(245, 241, 241);\r\n    background-color: rgba(70, 33, 206, 0.96);\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .dx-button:not([disabled]):hover {\r\n    background-color: rgb(91, 103, 107);\r\n    color: white;\r\n  }\r\n  \r\n  .dx-button[disabled] {\r\n    color : rgb(187, 187, 187);\r\n    background-color: rgba(230, 230, 229, 0.96);\r\n  }\r\n\r\n*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main